<template>
  <b-modal
      :visible="show"
      @hidden="hideEvents"
      :title=title
      :id="modalId"
  >
    <vue-element-loading :active="loading" :is-full-screen="false"/>
    <b-form>
      <p class="text-center alert-top" >
      <alert />
      </p>
      <p class="text-center">You are removing
        <br /><strong>{{selectedCount}} {{actionLabel}}</strong> from the <strong>'{{ workplans }}'</strong>
        <br />{{ workplanLabel }}.
        <br />The {{actionLabel}} will no longer be shown with a work plan due date.</p>

      <p class="text-center">Please confirm you have permission to do this.</p>
    </b-form>
    <template slot="modal-footer">
      <b-button
          variant="outline-secondary"
          @click="cancel"
      >
        CANCEL
      </b-button>
      <b-button
          class="btn-arrow"
          variant="primary"
          :disabled="workPlanDisabled"
          @click="removeWorkPlans"
      >
        CONFIRM
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ModalMixin from '@/components/Modal/ModalMixin';
import Alert from "@/components/icon/Alert";


export default {
  name: 'Remove-From-Work-Plan-Modal',
  components: {
    Alert
  },
  mixins: [ModalMixin],
  data() {
    return {
      modalId: 'removeFromWorkPlanModal',
      loading: false,
      value: [],
      options: [],
    };
  },
  computed: {
    ...mapGetters({
      clientId: 'userClientId',
    }),
    workPlanDisabled() {
      const length = this.validWorkPlanActions().length;
      return length === 0  || this.loading;
    },
    title() {
      const length = this.validWorkPlanActions().length;
      const actionLabel = length === 1 ? 'action' : 'actions';
      return `Remove ${length} ${actionLabel} from work plan`;
    },

    actionLabel() {
      const length = this.validWorkPlanActions().length;
      return length === 1 ? 'action' : 'actions';
    },

    workplanLabel() {
      return this.numberOfPlan === 1 ? 'work plan' : 'work plans';
    },

    workplans() {
      const names = this.validWorkPlanActions().map(node => node.data.workPlanName);
      const uniqueNames = [...new Set(names)];
      return uniqueNames.join(', ');
    },

    numberOfPlan() {
      const names = this.validWorkPlanActions().map(node => node.data.workPlanName);
      const uniqueNames = [...new Set(names)];
      return uniqueNames.length;
    },

    selectedCount() {
      return this.validWorkPlanActions().length;
    },
  },
  methods: {
    validWorkPlanActions() {
      return this.nodes.filter(node => node.data.workPlanId);
    },
    getActionIds() {
      return this.validWorkPlanActions().map(node => node.data.clientActionId);
    },
    async removeWorkPlans() {
      const totalActions = this.validWorkPlanActions().length
      if (totalActions === 0 ) {
        return;
      }

      this.loading = true;

      try {
        await this.$store.dispatch('removeWorkPlan', {
          clientActionIds: this.getActionIds(),
        });

        const workPlanLabel = this.numberOfPlan > 1 ? 'work plans' : 'work plan';
        const notifyMsg = `${totalActions} ${this.actionLabel} successfully removed from the ${this.workplans} ${workPlanLabel}.`;

        this.$notify({
          title: 'Success',
          text: notifyMsg,
          type: 'success',
        });
        await this.$store.dispatch('refreshActions');
      } catch (e) {
        this.$notify({
          title: 'Error',
          text: 'Something went wrong. Please try again later.',
          type: 'error',
        });
      } finally {
        this.hideModal();
      }
    },

    cancel () {
      const text = `Removal of ${this.selectedCount} ${this.actionLabel} from ${this.workplans} work plan cancelled`;
      this.$notify({
        title: 'Cancelled',
        text,
        type: 'error',
      });

      this.hideModal();
    },
  },
  async mounted() {
  },
};
</script>

<style lang="scss" scoped>
.modal {
  .btn.btn-arrow {
    min-width: 140px;
  }

  .btn-outline-secondary + .btn-arrow {
    margin: auto;
    margin-right: 0;
  }

  .alert-top {
    margin-top: 30px;
  }
}
</style>
